<template>
    <div id="step4">
        <h3><img src=".././assets/images/step4-title.svg"> 数量を入力する</h3>
        <b-form-input class="input_item_number" v-model="set_number" placeholder="数量"></b-form-input>セット
    </div>
</template>

<script>
    export default {
        name: 'STEP4',
        watch: {
            /**
             * 全角→半角
             * @param v
             */
            set_number : function(v) {
                this.set_number = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) })
            },
        },
        computed: {
            set_number: {
                get: function () {
                    return this.$store.state.step4_data.set_number
                },
                set: function (value) {
                    this.$store.commit('updateSetNumber', value)
                }
            }
        },
        data() {
            return {
            }
        },
    }
</script>

<style scoped>

</style>